import { Input, type InputProps } from "@mantine/core";
import React from "react";
import useSavedCursorPosition from "src/hooks/useSavedCursorPosition";

import { useLogbookRefsContext } from "../Logbook/LogbookRefsContext";

interface Props extends InputProps {
  numberRef: { current: HTMLInputElement | HTMLTextAreaElement | null };
  id: string;
  onChange: (value: any, lp: number) => void;
  setNumber: (value: string) => void;
  lp: number;
  min?: number;
  max?: number;
  maxLength?: number;
  value: string | number;
}
const CoordinateCell = ({
  id,
  numberRef,
  setNumber,
  onChange,
  lp,
  ...props
}: Props) => {
  const { ref: addToRefs, onKeyDown } = useLogbookRefsContext(`${id}_${lp}`);
  const { handleFocus, handleBlur, setCursorPosition } = useSavedCursorPosition(
    `${id}_${lp}`,
    numberRef,
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (/^\d*$/.test(inputValue)) {
      event.target.value = inputValue.toString();
      setCursorPosition();
      setNumber(inputValue);
      onChange(inputValue, lp);
    }
  };

  return (
    <Input
      type="text"
      {...props}
      onChange={handleChange}
      ref={ref => {
        numberRef.current = ref;
        addToRefs(ref);
      }}
      onKeyDown={onKeyDown}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  );
};
export default CoordinateCell;
